<template>
  <div class="container container--narrow">
    <div class="t-center pdt-50">
        <div v-if="!!contents">
          <div class="t-headline3 font-r mgb-24 t-color-headlineBlack">"{{ contents }}"</div>
          <div class="t-headline8 font-r mgb-4">{{ $t('1453') }}
          </div>
          <div class="t-body1 t-center font-r t-color-bodyGrayA">{{ $t('1454') }}</div>
        </div>
        <div v-else>
           <img src="/images/no-degree-data-image.svg" alt="" class="mgt-50 mgx-auto mgb-24 icon200">
            <div class="t-headline8 font-r mgb-4">{{ $t('1494') }}</div>
            <div class="t-body1 t-center font-r t-color-bodyGrayA">{{ $t('1495') }}</div>
        </div>
    </div>

  </div>
</template>

<script>
/**
 * 데이터 없음 컴포넌트(no data Components)
 *
 * @author minkyoung.park@emcast.com
 */

// Components/Mixin/Extend/API define
export default {
   props:['contents'],
}
</script>
